import { NavLink, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, BookOpen, Brain, PawPrint, Trophy, Gamepad2 } from 'lucide-react';

const navItems = [
  { to: '/', icon: Home, label: 'Home' },
  { to: '/species', icon: PawPrint, label: 'Species' },
  { to: '/learn', icon: BookOpen, label: 'Learn' },
  { to: '/quiz', icon: Brain, label: 'Quiz' },
  { to: '/games', icon: Gamepad2, label: 'Games' },
];

export function Navigation() {
  const location = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 safe-bottom">
      <div className="glass border-t border-white/20 dark:border-slate-700/50">
        <div className="max-w-lg mx-auto">
          <ul className="flex justify-around items-center h-16">
            {navItems.map(({ to, icon: Icon, label }) => {
              const isActive = location.pathname === to ||
                (to !== '/' && location.pathname.startsWith(to));

              return (
                <li key={to}>
                  <NavLink
                    to={to}
                    className="flex flex-col items-center justify-center px-3 py-2 rounded-xl transition-colors relative"
                  >
                    {isActive && (
                      <motion.div
                        layoutId="activeNav"
                        className="absolute inset-0 bg-otter-100 dark:bg-otter-900/50 rounded-xl"
                        initial={false}
                        transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                      />
                    )}
                    <Icon
                      className={`w-6 h-6 relative z-10 transition-colors ${
                        isActive
                          ? 'text-otter-600 dark:text-otter-400'
                          : 'text-slate-400 dark:text-slate-500'
                      }`}
                    />
                    <span
                      className={`text-xs mt-1 relative z-10 font-medium transition-colors ${
                        isActive
                          ? 'text-otter-600 dark:text-otter-400'
                          : 'text-slate-400 dark:text-slate-500'
                      }`}
                    >
                      {label}
                    </span>
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </nav>
  );
}
